// Lib
import React, { useCallback } from 'react';
import { Typography } from '@mui/material';

// Components
import Dropzone from '../../../DropZone';
import Button from '../../../Button';
import Feather from '../../../Feather';
import Error from '../Error';

// Constants
import { selectAddressImportFile } from '../../../../constants/addressBook';

// Hooks
import useUser from '../../../../hooks/useUser';
import Progress from './Progress';
import { useStyles } from './FileSelectionStyles';

const FileSelection = ({
  importedAddresses,
  onDrop,
  incorrectFormatMessage,
  uploadingProgress,
  onCancelUploading,
  withSpinner,
}) => {
  const { isKiteUser } = useUser();
  const fileName = importedAddresses.file?.name;
  const { classes } = useStyles({ isKiteUser, fileName });

  const renderContent = useCallback(() => {
    if (uploadingProgress && withSpinner) {
      return (
        <Progress
          value={uploadingProgress}
          onCancelUploading={onCancelUploading}
        />
      );
    }

    return (
      <Dropzone
        file={importedAddresses.file}
        mult
        onDrop={onDrop}
        accept={{
          'text/csv': ['.csv'],
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            '.xlsx',
          ],
        }}>
        <div className={classes.content}>
          <Feather
            className={classes.book}
            nativeColor
            type={fileName ? 'emptyBook' : 'book'}
          />
          {fileName ? (
            <Typography className={classes.fileName} variant="h3">
              {fileName}
            </Typography>
          ) : (
            <p className={classes.message}>{selectAddressImportFile}</p>
          )}
          {fileName ? (
            <Button
              className={classes.button}
              data-testid="import-addresses-replace-button">
              Replace
            </Button>
          ) : (
            <p className={classes.text}>Or Drag And Drop It Here</p>
          )}
        </div>
      </Dropzone>
    );
  }, [
    uploadingProgress,
    classes,
    fileName,
    importedAddresses.file,
    onCancelUploading,
    onDrop,
    withSpinner,
  ]);

  return (
    <>
      {incorrectFormatMessage && (
        <Error fontSize={18} error={incorrectFormatMessage} />
      )}
      {renderContent()}
    </>
  );
};

export default FileSelection;
